import { getWeWorkLeadMetadataFromCookies } from '@wework/www-form-utils';
import { varsFromServer } from './client_side_injection_vars';
import { geoData } from './geo';

// Valid track event names
// analytics.track(EVENT_NAME)
export const EventNameTypes = {
  form: 'Form Submission',
  interaction: 'Interaction',
  page: 'Loaded a Page',
  bucket: 'Bucket',
  timing: 'Timing',
  signupActivity: 'Signup Activity',
  chatActivity: 'Chat Activity',
  availabilityPayload: 'Availability Payload',
  checkout3ds: '3DS Checkout',
  startSearch: 'Start Search',
  searchBarFilterSelected: 'Search Bar Filter Selected',
  searchBarFilterClicked: 'Search Bar Filter Clicked',
  cta: 'CTA',
  // Tracking plan implemented April-May-June 2022 - TODO - Remove this line
  accountCreated: 'Account Created',
  signedIn: 'Signed In',
  buildingSearched: 'Buildings Searched',
  buildingListViewed: 'Building List Viewed',
  buildingListFiltered: 'Building List Filtered',
  promotionViewed: 'Promotion Viewed',
  promotionClicked: 'Promotion Clicked',
  buildingClicked: 'Building Clicked',
  productViewed: 'Product Viewed',
  cartViewed: 'Cart Viewed',
  checkoutStarted: 'Checkout Started',
  paymentInfoEntered: 'Payment Info Entered',
  orderCompleted: 'Order Completed',
  orderUpdated: 'Order Updated',
  promoCodeEntered: 'Promo Code Entered',
  promoCodeApplied: 'Promo Code Applied',
  promoCodeDenied: 'Promo Code Denied',
  promoCodeRemoved: 'Promo Code Removed',
  buildingShareOptionsOpened: 'Building Share Options Opened',
  buildingShared: 'Building Shared',
  experimentGroupAssigned: 'Experiment Group Assigned',
  formFieldEntered: 'Form Field Entered',
  formSubmitHovered: 'Form Submit Hovered',
  formSubmitted: 'Form Submitted',
  formReceived: 'Form Received',
  errorMessageDisplayed: 'Error Message Displayed',
  buildingLinkAWPClick: 'Building Link AWP Clicked',
  buildingLinkClicked: 'View Building CTA Clicked',
  inventoryLinkClicked: 'View Inventory CTA Clicked',
  openGetInTouchSearchForm: 'Open Get In Touch Form Search',
  openExpandableBuildingCard: 'Expand Building Card',
  collapseExpandableBuildingCard: 'Collapse Building Card'
};

// Google Tag Manager window.dataLayer Event names
export const DataLayerEventTypes = {
  CHECKOUT_PAYMENT_LEGACY: 'commons signup',
  CHECKOUT_PAYMENT: 'checkout payment complete',
  LEAD_SUBMISSION: 'lead submitted'
};

export const PODDAnalyticsEvents = {
  'Service retainer': 'Click - Expanded Service Retainer Fee Info',
  'Set-up fee': 'Click - Expanded Setup Fee Info'
};

export function getSegmentAnonymousId() {
  const anonId = window.localStorage.ajs_anonymous_id;
  if (!anonId || typeof anonId !== 'string') {
    return '';
  }
  return JSON.parse(anonId);
}

export function makeSegmentTrackCall(event, properties) {
  const { analyticsGlobals = {}, location = {} } = window;

  const eventProperties = {
    path: location.pathname,
    ...properties,
    userId: analyticsGlobals.userId,
    request_id: analyticsGlobals.requestId,
    app_version: analyticsGlobals.appVersion,
    experiments: varsFromServer.experimentsString,
    app_name: 'vanilla',
    url: location.href,
    heapUserId: properties.heapUserId || (global.GTMheapId && global.GTMheapId.userId),
    segment_anonymous_id: getSegmentAnonymousId()
  };

  if (global.analytics) {
    global.analytics.track(event, eventProperties, {
      integrations: {
        Heap: true
      }
    });
  }
}

export function triggerDataLayer(events) {
  global.analytics.ready(() => {
    window.dataLayer.push(...events);
  });
}

export function trackInteraction(properties) {
  makeSegmentTrackCall(EventNameTypes.interaction, properties);
}
// Tracking plan implemented April-May-June 2022 - TODO - Remove this line
export function trackAccountCreated(properties) {
  makeSegmentTrackCall(EventNameTypes.accountCreated, properties);
}
export function trackSignedIn(properties) {
  makeSegmentTrackCall(EventNameTypes.signedIn, properties);
}
export function trackBuildingSearched(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingSearched, properties);
}
export function trackBuildingListViewed(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingListViewed, properties);
}
export function trackBuildingListFiltered(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingListFiltered, properties);
}
export function trackPromotionViewed(properties) {
  makeSegmentTrackCall(EventNameTypes.promotionViewed, properties);
}
export function trackPromotionClicked(properties) {
  makeSegmentTrackCall(EventNameTypes.promotionClicked, properties);
}
export function trackBuildingClicked(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingClicked, properties);
}
export function trackProductViewed(properties) {
  makeSegmentTrackCall(EventNameTypes.productViewed, properties);
}
export function trackCartViewed(properties) {
  makeSegmentTrackCall(EventNameTypes.cartViewed, properties);
}
export function trackCheckoutStarted(properties) {
  makeSegmentTrackCall(EventNameTypes.checkoutStarted, properties);
}
export function trackPaymentInfoEntered(properties) {
  makeSegmentTrackCall(EventNameTypes.paymentInfoEntered, properties);
}
export function trackOrderCompleted(properties) {
  makeSegmentTrackCall(EventNameTypes.orderCompleted, properties);
}
export function trackOrderUpdated(properties) {
  makeSegmentTrackCall(EventNameTypes.orderUpdated, properties);
}
export function trackPromoCodeEntered(properties) {
  makeSegmentTrackCall(EventNameTypes.promoCodeEntered, properties);
}
export function trackPromoCodeApplied(properties) {
  makeSegmentTrackCall(EventNameTypes.promoCodeApplied, properties);
}
export function trackPromoCodeDenied(properties) {
  makeSegmentTrackCall(EventNameTypes.promoCodeDenied, properties);
}
export function trackPromoCodeRemoved(properties) {
  makeSegmentTrackCall(EventNameTypes.promoCodeRemoved, properties);
}
export function trackBuildingShareOptionsOpened(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingShareOptionsOpened, properties);
}
export function trackBuildingShared(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingShared, properties);
}
export function trackExperimentGroupAssigned(properties) {
  makeSegmentTrackCall(EventNameTypes.experimentGroupAssigned, properties);
}
export function trackFormFieldEntered(properties) {
  makeSegmentTrackCall(EventNameTypes.formFieldEntered, properties);
}
export function trackFormSubmitHovered(properties) {
  makeSegmentTrackCall(EventNameTypes.formSubmitHovered, properties);
}
export function trackFormSubmitted(properties) {
  makeSegmentTrackCall(EventNameTypes.formSubmitted, properties);
}
export function trackFormReceived(properties) {
  makeSegmentTrackCall(EventNameTypes.formReceived, properties);
}
export function trackErrorMessageDisplayed(properties) {
  makeSegmentTrackCall(EventNameTypes.errorMessageDisplayed, properties);
}
export function trackBuildingAWPClick(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingLinkAWPClick, properties);
}
export function trackBuildingCTALinkClicked(properties) {
  makeSegmentTrackCall(EventNameTypes.buildingLinkClicked, properties);
}
export function trackInventoryCTALinkClicked(properties) {
  makeSegmentTrackCall(EventNameTypes.inventoryLinkClicked, properties);
}
export function trackGetInTouchFormOpen(properties) {
  makeSegmentTrackCall(EventNameTypes.openGetInTouchSearchForm, properties);
}
export function trackExpandableCardOpen(properties) {
  makeSegmentTrackCall(EventNameTypes.openExpandableBuildingCard, properties);
}
export function trackExpandableCardCollapse(properties) {
  makeSegmentTrackCall(EventNameTypes.collapseExpandableBuildingCard, properties);
}

export function setupScrollAnalyticsTracking({ label, selector }) {
  const target = document.querySelector(selector);
  if (!target) {
    return;
  }
  let isTrackedEventSent = false;

  const observer = new IntersectionObserver((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting && !isTrackedEventSent) {
      trackInteraction({ label });
      isTrackedEventSent = true;
    }
  });

  observer.observe(target);
}

export function setupScrollAnalyticsTrackingBelowElement({ label, selector }) {
  const target = document.querySelector(selector);
  if (!target) {
    return;
  }
  let didSendTrackEvent = false;

  const observer = new IntersectionObserver((entries) => {
    const [{ isIntersecting, boundingClientRect }] = entries;
    if (!isIntersecting && !didSendTrackEvent && boundingClientRect.bottom < 0) {
      trackInteraction({ label });
      didSendTrackEvent = true;
    }
  });

  observer.observe(target);
}

export function getGoogleAnalyticsData() {
  return new Promise((resolve, reject) => {
    try {
      const { analyticsGlobals = {} } = window;
      const { google_analytics: googleAnalytics = {} } = getWeWorkLeadMetadataFromCookies();

      if (!googleAnalytics.gauserid) {
        googleAnalytics.gauserid = analyticsGlobals.userId;
      }

      if ((!googleAnalytics.gaclientid || !googleAnalytics.gatrackid) && window.ga) {
        // schedule callback function execution when GA library is loaded and ready
        return window.ga((defaultTracker) => {
          const tracker = defaultTracker || window.ga.getAll()[0];
          googleAnalytics.gaclientid = tracker.get('clientId');
          googleAnalytics.gatrackid = tracker.get('trackingId');
          resolve(googleAnalytics);
        });
      }

      resolve(googleAnalytics);
    } catch (err) {
      reject(err);
    }
  });
}

function isValidScrollDistanceTracker({ breakpoint, label }) {
  return breakpoint >= 0 && breakpoint <= 100 && typeof label === 'string';
}

function getDocumentScrollPercentage() {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  const offset = document.documentElement.clientHeight;
  return Math.round((scrollTop / (scrollHeight - offset)) * 100);
}

export function setupScrollDistanceAnalyticsTracking(trackers, callback = trackInteraction) {
  if (!Array.isArray(trackers) || trackers.length === 0) {
    throw new TypeError('Function setupScrollDistanceAnalyticsTracking only accepts non-empty arrays');
  }

  if (trackers.some((tracker) => !isValidScrollDistanceTracker(tracker))) {
    throw new TypeError('Invalid setupScrollDistanceAnalyticsTracking arguments');
  }

  const scrollTrackers = trackers.map((tracker) => ({ ...tracker })); // full copy
  let isScrollTicking = false;
  let currentScrollPercentage = 0;

  window.addEventListener('scroll', () => {
    currentScrollPercentage = getDocumentScrollPercentage();
    if (isScrollTicking) return undefined;

    window.requestAnimationFrame(() => {
      let tracker = null;

      for (let index = scrollTrackers.length - 1; index >= 0; --index) {
        tracker = scrollTrackers[index];
        if (currentScrollPercentage >= tracker.breakpoint) {
          callback({ label: tracker.label });
          scrollTrackers.splice(index, 1);
        }
      }

      isScrollTicking = false;
    });

    isScrollTicking = true;
  });
}

export async function sendCountryCodeToGtm() {
  const { countryCode } = await geoData;
  triggerDataLayer([{ event: 'Geo Data', 'Geo - Country Code': countryCode }]);
}

export const trackAnalyticsInteractionByLink = (link, moduleName = '') => {
  trackInteraction({ label: `Click - ${moduleName} - ${link.textContent.trim()} - Link` });
};
